import { createContext } from "react";

const resyncState = createContext();

export default resyncState;